const DAILY = { value: "DAILY", displayName: "Täglich" };
const WEEKLY = { value: "WEEKLY", displayName: "Wöchentlich" };
const MONTHLY = { value: "MONTHLY", displayName: "Monatlich" };

// Mirrors the backend ScheduledTaskStartRequirement: the backend rejects an earlier delay (daily/weekly) or start day (monthly).
export const SCHEDULED_TASK_START_REQUIREMENTS = {
    PAYPAL: { minimumDelayDays: 3, minimumDayOfMonth: 3 },
    STRIPE_PAYMENTS: { minimumDelayDays: 1, minimumDayOfMonth: 2 },
};

export const AUTO_IMPORT_PERIOD = {
    DAILY, 
    WEEKLY, 
    MONTHLY
};
